import styled from "styled-components"

const Title = styled.h2`

    &::after {
        background-color: ${(props) => props.theme.a_color_gradients.a_dark};
    }
    }
`
const NotificationPopupWrapper = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const NotificationPopupButton = styled.button`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const NotificationPopupContent = styled.div`
  & a::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  & h2,
  & h3,
  & h4 {
    color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const Separator = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_medium};
`

export {
  Title,
  NotificationPopupWrapper,
  NotificationPopupButton,
  NotificationPopupContent,
  Separator,
}
